var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":_vm.openFullscreen,"hide-overlay":_vm.openFullscreen,"content-class":"cw-business-loan-signees-dialog","max-width":"800","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.dialogComponent)?_c(_vm.dialogComponent,_vm._b({tag:"component"},'component',{
      data: Object.assign({}, _vm.dialogProps,
        {openFullscreen: _vm.openFullscreen}),
    },false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }